import React from 'react';
import {useSelector} from 'react-redux';
import {Routes} from "../../../routes";
import {RootState} from "../../../store";
import PersonalSignup from "../../../components/personalSignup"
import {
  FormCard,
  FormCardHeader,
  Line,
  LinkContainer,
  StyledLink,
} from 'styles/styled';
import styled from "styled-components";
import {Colors, Spacing} from "styles/constants";
import {AnimatePresence, motion} from "framer-motion";
import MotionDiv from "../../../components/helperComponents/motionDiv";

const FormCardHeaderExtended = styled(FormCardHeader)`
  margin-bottom: ${Spacing.Space2};
`;

const FormCardHeaderSubtext = styled(FormCardHeader)`
  color: ${Colors.SlateDark};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

const PersonalOnly = () => {

  const urlExtension = useSelector((state: RootState) => state.app.urlExtension);

  return (
    <>
      <FormCard>
        <FormCardHeaderExtended>Welcome to BitPay</FormCardHeaderExtended>
        <FormCardHeaderSubtext>BitPay provides an easy way to pay with and get paid in crypto. Create an account below to get started.</FormCardHeaderSubtext>
        <Line/>
        <AnimatePresence exitBeforeEnter>
            <MotionDiv
              key="personal"
            >
              <PersonalSignup/>
            </MotionDiv>
        </AnimatePresence>
      </FormCard>
      <LinkContainer>
        <p>Already have an account? <StyledLink role="link" to={Routes.LOGIN + urlExtension}>Login</StyledLink></p>
      </LinkContainer>
    </>

)
};

export default PersonalOnly;
